import React, { useState, useEffect } from 'react';
import pencilIcon from './assets/pencil.png';

const styles = {
  documentLabels: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 8,
    fontSize: '17px',
    color: 'White',
    fontWeight: '600',
    padding: '6px 0px'
  },
  doc1Label: {
    padding: '0',
    textAlign: 'left',
    overflowWrap: 'break-word', // or wordWrap: 'break-word' for older browsers
    wordBreak: 'break-word',
  },
  doc2Label: {
    padding: '0',
    textAlign: 'left',
    overflowWrap: 'break-word', // or wordWrap: 'break-word' for older browsers
    wordBreak: 'break-word',    // ensures long words break
  }, 
  docNameContainer: {
    cursor: 'pointer',
  },
  docNameInput: {
    fontSize: '1rem',
    padding: '4px 8px',
    width: '100%',
    boxSizing: 'border-box',
  },
};

const DocName1 = ({ docname1, claimId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(docname1);
  const [originalName, setOriginalName] = useState(docname1);

  // Keep local state synced if docname1 prop changes
  useEffect(() => {
    setName(docname1);
    setOriginalName(docname1);
  }, [docname1]);

  const saveName = async () => {
    setIsEditing(false);
    if (name.trim() === originalName.trim()) return; // no change

    try {
      const body = {
        doc1_name: name?.trim() || "UNCHANGED",
        doc2_name: "UNCHANGED"
      };

      const response = await fetch(`${process.env.REACT_APP_DOCNAMES}/${claimId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to update");
      }

      setOriginalName(name);
    } catch (err) {
      console.error("⚠️ Error updating doc name:", err);
      setName(originalName); // revert if failed
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      saveName();
    } else if (e.key === 'Escape') {
      setIsEditing(false);
      setName(originalName); // revert
    }
  };

  return (
    <div style={styles.documentLabels}>
      <div style={{...styles.doc1Label }}>
        {isEditing ? (
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={saveName}  // Save on blur instead of revert
            autoFocus
            style={styles.docNameInput}
          />
        ) : (
          <span
            style={{ ...styles.docNameContainer, ...styles.doc1Label }}
            onClick={() => setIsEditing(true)}
            title="Click to Edit Document Name"
          >
            {name}&nbsp;&nbsp;<img style={{height: '16px', width: 'auto', marginBottom: '-2px'}} src={pencilIcon} alt="Pencil Icon" />
          </span>
        )}
      </div>

    </div>
  );
};

export default DocName1;
